import type { UpdateContractStatusRequestPayload, UpdateContractStatusResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import {
  invalidateContractsQueries,
  invalidateCustomersQueries,
  invalidateBillingRevenueQueries,
} from '../../utils/query-invalidation';

export function useUpdateContractStatus(
  contractId: string,
  options?: UseMutationOptions<UpdateContractStatusResponse, unknown, UpdateContractStatusRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ['updateContractStatus'],
    (updateContractStatusRequest) => {
      const api = getPrivateApi();

      return api.updateContractStatus({
        contractId,
        updateContractStatusRequest,
      });
    },
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey.includes(contractId),
          }),
          invalidateContractsQueries(queryClient),
          invalidateCustomersQueries(queryClient),
          invalidateBillingRevenueQueries(queryClient),
        ]);
      },
      ...options,
    },
  );
}
